import { FC } from 'react';

import { LoadingIndicatorProps } from './types';

import { styled } from '@mui/material/styles';
import { keyframes } from '@emotion/react';

const LoadingIndicator: FC<LoadingIndicatorProps> = ({
  color,
  size = 'medium',
  className,
}) => {
  return (
    <BouncingLoader className={className}>
      <Dot color={color} size={size} />
      <Dot color={color} size={size} />
      <Dot color={color} size={size} />
    </BouncingLoader>
  );
};

const BouncingLoader = styled('div')`
  display: flex;
  justify-content: center;
  div:nth-child(2) {
    animation-delay: 0.2s;
  }
  div:nth-child(3) {
    animation-delay: 0.4s;
  }
`;

const DotAnimation = keyframes`
  to {
    opacity: 0.1;
    transform: translateY(-2px);
  }
`;

const Dot = styled('div')<{
  color: string;
  size: NonNullable<LoadingIndicatorProps['size']>;
}>`
  width: 4px;
  height: 4px;
  margin: 3px ${props => (props.size === 'large' ? '4px' : '2px')};
  border-radius: 50%;
  background-color: ${props => props.color};
  opacity: 1;
  transform: translateY(4px);
  animation: ${DotAnimation} 0.6s infinite alternate;
`;

export default LoadingIndicator;
